import request from '@/utils/request'


// 查询手设备版本列表
export function listVersion(query) {
  return request({
    url: '/device/version/list',
    method: 'get',
    params: query
  })
}

// 查询手设备版本分页
export function pageVersion(query) {
  return request({
    url: '/device/version/page',
    method: 'get',
    params: query
  })
}

// 查询手设备版本详细
export function getVersion(data) {
  return request({
    url: '/device/version/detail',
    method: 'get',
    params: data
  })
}

// 新增手设备版本
export function addVersion(data) {
  return request({
    url: '/device/version/add',
    method: 'post',
    data: data
  })
}

// 修改手设备版本
export function updateVersion(data) {
  return request({
    url: '/device/version/edit',
    method: 'post',
    data: data
  })
}

// 删除手设备版本
export function delVersion(data) {
  return request({
    url: '/device/version/delete',
    method: 'post',
    data: data
  })
}
